module.exports = __webpack_public_path__ + "img/img_web_3.b8ef5618.jpg";